import { IStyle, classNamesFunction } from '@fluentui/react';
import { ContactFormBrand } from '../../../models/apiModels';
import { isBranded } from '../../../utilities';
import { IAppNavProps } from '../presentationalComponents/Navigation';
import { IThemedProp } from './themesUI';

export interface IMainNavigationStyles {
  navContainer: IStyle;
  tabContainer: IStyle;
}

export const getNavIconStyles = (props: IThemedProp, isSelected: boolean): IStyle => {
  const { theme } = props;
  return {
    marginRight: '16px',
    fontSize: '14px',
    borderBottom: isSelected ? `2px solid ${theme ? theme.palette.themeDarker : '#2e6da4'
      }` : '2px solid transparent',
    fontFamily: "'Segoe UI',SegoeUI,'Helvetica Neue',Arial,sans-serif",
    paddingBottom: '6px',
    paddingTop: '6px',
    cursor: 'pointer',
    color: theme.palette.neutralPrimary,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '200px',
    overflowX: 'hidden',
    display: 'inline-block',
    transition: 'left 0.267s cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s, right 0.267s cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s',
    '&:focus-visible': {
      outline: `${theme.palette.neutralPrimary} solid 2px !important`,
    },
  };
};

export const getMainNavigationStyles = (
  props: IAppNavProps
): IMainNavigationStyles => {
  const { appName, isNonAgave } = props;
  return {
    navContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: isNonAgave ? '0px' : '15px',
      marginBottom: isBranded(appName) && appName.indexOf(ContactFormBrand.SignUp) === -1 ? '20px' : 0,
    },
    tabContainer: {
      flexGrow: 1,
    },
  };
};

export const getMainNavClassNames = classNamesFunction<
  {},
  IMainNavigationStyles
>();
